import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
    userOptions: function () { return getUserConfiguration().UserOptions; },
})(function isMessagePreviewOptionDirty(state) {
    var savedOptions = state.userOptions;
    var showPreviewTextInListView = getFallbackValueIfNull(state.optionState.showPreviewTextInListView, savedOptions.ShowPreviewTextInListView);
    return showPreviewTextInListView !== savedOptions.ShowPreviewTextInListView;
});
//# sourceMappingURL=isMessagePreviewOptionDirty.js.map